export default __webpack_public_path__ + "static/media/market icon Dark.9b80f5ea.svg";